/**
 * The type of a recommendation card action button. This is provided by the backend.
 * - `ROVO`: renders a RovoChat icon followed by the button label.
 * - `REDIRECT`: renders the button label followed by a right arrow icon.
 *
 * This type is on its own here so it can be shared by `recommendation-card`,
 * `recommendation-button`, and `compact-card` without introducing import cycles.
 */
export type RecommendationButtonType = 'ROVO' | 'REDIRECT';

export const RecommendationButtonType = {
	ROVO: 'ROVO',
	REDIRECT: 'REDIRECT',
} as const;
